import { TranslateLoader } from '@ngx-translate/core';
import { HttpClient } from '@angular/common/http';
import { Observable, forkJoin } from 'rxjs';
import { map } from 'rxjs/operators';

export class MultiTranslateHttpLoader implements TranslateLoader {
  constructor(private http: HttpClient, private prefix: string, private suffix: string) {}

  getTranslation(lang: string): Observable<any> {
    // Lista de arquivos de tradução a serem carregados
    const paths = [
      `${this.prefix}${lang}/dashboard${this.suffix}`,
      `${this.prefix}${lang}/common${this.suffix}`,
      `${this.prefix}${lang}/integration${this.suffix}`,
      //`${this.prefix}${lang}/header${this.suffix}`,
    ];

    // Faz requisições para todos os arquivos
    const requests = paths.map(path => this.http.get(path));

    // Combina as respostas e mescla os objetos
    return forkJoin(requests).pipe(
      map(response => Object.assign({}, ...response))
    );
  }
}
